<div class="container-fluid promotionsContainer">

  
    <div class="col-3 col-md-3 col-lg-3">
      <div class="content-area__white-box">
        <div class="content-area__white-box__heading">
          <h3>{{ "promotions.instructions.header" | translate}}</h3>
        </div>
        <div style="margin-bottom: 10px;" class="instructionsPart1">
          <p>{{ "promotions.instructions.part1" | translate}}</p>
          <p>{{ "promotions.instructions.part2" | translate}}</p>
        </div>
        <div class="instructionsContacts">
          <p class="countryName">{{"promotions.instructions.canadaName" | translate }}</p>
          <p class="countryNumber">{{ "promotions.instructions.canadaNumber" | translate}}</p>
          <p class="countryName">{{"promotions.instructions.safetyName" | translate }}</p>
          <p class="countryNumber">{{ "promotions.instructions.safetyNumber" | translate}}</p>
          <p class="countryName">{{"promotions.instructions.usName" | translate }}</p>
          <p class="countryNumber">{{ "promotions.instructions.usNumber" | translate}}</p>
        </div>
        </div>
      </div> 
  
  <div class="col-9 col-md-9 col-lg-9 menus">
    <ng-container *ngFor="let menu of accordionMenus">
      <div type="button" class="collapsible" (click)="toggleCollapse($event, menu)">
        <i class="fa fa-chevron-down collapsible-logo" *ngIf="!menu.expanded"></i>
        <i class="fa fa-chevron-up collapsible-logo" *ngIf="menu.expanded"></i>
        {{menu.name}}
      </div>
      <div class="content">
        <ng-container *ngFor="let sub of menu.submenus">
          <div class="submenusContainer">
            <div type="button" class="collapsible subMenus" (click)="toggleCollapse($event, sub)">
              <i class="fa fa-chevron-down collapsible-logo" *ngIf="!sub.expanded"></i>
              <i class="fa fa-chevron-up collapsible-logo" *ngIf="sub.expanded"></i>
              {{sub.name}}
            </div>
            <div class="content">
              <ng-container *ngFor="let pro of sub.promotions">
                <ul>
                <li><a href="{{pro.url}}" target="_blank">{{pro.name}}</a></li>
              </ul>
              </ng-container>
             
            </div>
            </div>
        </ng-container>
      </div>
      <div class="line"></div>
      </ng-container>
     
   
  </div>

</div>
 